// import _ from 'lodash';

const discounts = {
  isLoading: {
    list: false,
    copyModal: false,
    copyForm: false,
    detailModal: false,
  },
  list: {},
  detail: null,
  form: null,
}
const DiscountsReducer = function (state = discounts, action) {
  switch (action.type) {
    case 'TOGGLE_DISCOUNT_LOADING': {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          [action.key]: action.value,
        },
      }
    }
    case 'UPDATE_DISCOUNTS': {
      let newList = {}
      Object.entries(action.list).forEach(([key, value]) => (newList[key] = { ...state.list[key], ...value }))
      return {
        ...state,
        list: newList,
      }
    }
    case 'REPLACE_DISCOUNT_DETAIL': {
      return {
        ...state,
        detail: action.detail,
      }
    }
    case 'UPDATE_DISCOUNT_DETAIL': {
      return {
        ...state,
        detail: {
          ...state.detail,
          [action.key]: action.value,
        },
      }
    }
    case 'REMOVE_DISCOUNT': {
      let newList = { ...state.list }
      const key = action.key

      if (typeof key != 'undefined') {
        delete newList[key]
      }

      return {
        ...state,
        list: newList,
        detail: null,
      }
    }
    case 'REPLACE_DISCOUNT_FORM': {
      return {
        ...state,
        form: action.detail,
      }
    }
    case 'UPDATE_DISCOUNT_FORM': {
      return {
        ...state,
        form: {
          ...state.form,
          [action.key]: action.value,
        },
      }
    }
    default: {
      return state
    }
  }
}

export default DiscountsReducer
